import { cn } from '@/lib/utils'

/** GitHub release page for a version -- release-please tags each release `v<version>`. */
function releaseUrl(version: string): string {
  return `https://github.com/b-a-b-i-s/fit-editor/releases/tag/v${version}`
}

/**
 * The running release, e.g. "FIT Editor v0.3.0" -- from `__APP_VERSION__`,
 * set at build time -- linking to that release's notes on GitHub.
 */
export function AppVersion({ className }: { className?: string }) {
  return (
    <p className={cn('text-muted-foreground text-xs', className)}>
      <a
        href={releaseUrl(__APP_VERSION__)}
        target="_blank"
        rel="noopener noreferrer"
        title="Release notes on GitHub (opens in a new tab)"
        className="hover:text-foreground focus-visible:ring-ring rounded-sm underline-offset-2 outline-none hover:underline focus-visible:ring-2"
      >
        FIT Editor v{__APP_VERSION__}
      </a>
    </p>
  )
}
